const TICKET_PATTERN = /^[A-Za-z0-9_-]{43}$/

export function readLaunchTicket(hash: string): string | null {
  const value = hash.startsWith('#') ? hash.slice(1) : hash
  const ticket = new URLSearchParams(value).get('ticket')
  return ticket && TICKET_PATTERN.test(ticket) ? ticket : null
}

export function consumeLaunchTicket(): string | null {
  const ticket = readLaunchTicket(window.location.hash)
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`)
  return ticket
}
